import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { PrivacyPolicyComponent } from './login/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './login/terms-condition/terms-condition.component';
import { PortalComponent } from './_layout/portal-egresado/portal/portal.component';
import { PortalDocenteComponent } from './_layout/portal-docente/portal-docente/portal-docente.component';
import { PortalEmpresaComponent } from './_layout/portal-empresa/portal-empresa/portal-empresa.component';
import { ContactoComponent } from './_layout/contacto/contacto/contacto.component';
import { Error404Component } from './content/full-pages/error/error404/error404.component';
import { LoginEgresadoComponent } from './login/egresado/egresado.component';
import { LoginAdministradorComponent } from './login/administrador/administrador.component';
import { LoginEmpresaComponent } from './login/empresa/empresa.component';
import { LoginDocenteComponent } from './login/docente/docente.component';
import { UserRole } from './_models/userEnum';
import { EmpresaRegistroComponent } from './register/empresa-registro/empresa-registro.component';
import { PrivateLayoutEgresadoComponent } from './_layout/egresado/private-layout-egresado/private-layout-egresado.component';
import { PrivateLayoutEmpresaComponent } from './_layout/empresa/private-layout-empresa/private-layout-empresa.component';
import { PrivateLayoutDocenteComponent } from './_layout/docente/private-layout-docente/private-layout-docente.component';
import { PrivateLayoutAdminComponent } from './_layout/admin/private-layout-admin/private-layout-admin.component';
import { Error403Component } from './content/full-pages/error/error403/error403.component';
const appRoutes: Routes = [
  { path: 'privacypolicy', component: PrivacyPolicyComponent },
  { path: 'termCondition', component: TermsConditionComponent },
  // public views
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { 
        path: '', component: PortalComponent 
      },
      { 
        path: 'portal-empresa', component: PortalEmpresaComponent 
      },
      { 
        path: 'portal-docente', component: PortalDocenteComponent 
      },
      { 
        path: 'contacto', component: ContactoComponent 
      }
    ]
  },
  //login & register path
  {
    path: '',
    children: [
      { 
        path: 'login', component: LoginEgresadoComponent 
      },
      { 
        path: 'admin-access/utp2023', component: LoginAdministradorComponent 
      },
      { 
        path: 'login-empresa', component: LoginEmpresaComponent 
      },
      { 
        path: 'login-docente', component: LoginDocenteComponent 
      },
      {
        path: 'register-empresa', component: EmpresaRegistroComponent
      },
    ]
  },
  {
    path:'egresado',
    component : PrivateLayoutEgresadoComponent,
    children:
    [
      {
        path: '', 
        loadChildren: () => import('../app/content/egresado/egresado.module').then(m => m.EgresadoModule)
        , canActivate: [AuthGuard], data: { role: UserRole.Graduated }
      },
    ]
  },
  {
    path:'empresa',
    component : PrivateLayoutEmpresaComponent,
    children:
    [
      {
      path:'',
      loadChildren: () => import('../app/content/empresa/empresa.module').then((e)=>e.EmpresaModule)
      , canActivate: [AuthGuard], data: { role: UserRole.Company }
      }
    ]
  },
  {
    path:'docente',
    component : PrivateLayoutDocenteComponent,
    children:
    [
      {
      path:'',
      loadChildren: () => import('../app/content/docente/docente.module').then((e)=>e.DocenteModule)
      , canActivate: [AuthGuard], data: { role: UserRole.Professor }
      }
    ]
  },
  {
    path:'onlyadminaccess',
    component : PrivateLayoutAdminComponent,
    children:
    [
      {
        path:'',
        loadChildren: () => import('../app/content/admin/admin.module').then((e)=>e.AdminModule)
        , canActivate: [AuthGuard], data: { role: UserRole.Admin }
      }
    ]
  },
  // otherwise redirect to home
  {
    path:'errors/unauthorized',component:Error403Component
  },
  { path: '**', component: Error404Component },
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' });
